

let _total_slides = -1; 
let sketch_url = "";

function getSketchData(url) {
	return $.ajax({
		url: url,
		method: "GET",
		contentType: "application/json"
	});
}

function getSketchGeometry(data) {
	let vects = "";
	let newdata = [];
	const dataLen = data?.length;
	_total_slides = dataLen;

	for (let i = 0; i < dataLen; i++) {
		newdata.push(data[i]);
		let v = newdata[i].VECT;
		vects = vects.concat('', v);

		if (dataLen > 1 && i === dataLen - 1) {
			v = vects;
			let tot_area = newdata.reduce(function (accumulator, newdata) {
				return accumulator + parseFloat(newdata.AREA);
			}, 0);

			let dv = {
				AREA: tot_area.toLocaleString('en'),
				DESCRIB: 'All',
				ID: 999, 		
				LLINE: 999, 
				PARID: newdata[0].PARID, 
				TYPE: 'A', 	
				VECT: v
			};
			newdata.push(dv);
			_total_slides = newdata.length;
		}
	} 

	for (let i = 0; i < newdata.length; i++) {
		let v = newdata[i].VECT;

		let post_data = "gridunits=0&usecolors=" + paoDetails.modules.sketches.sketchesUseColor + "&width=450&height=450&vector=" + v;

		$.post("/sketch.server/sketchHandler1.ashx", post_data, (function (i) {
			return function (response) {
				newdata[i].RESPONSE = response;
				handleSketchSlides(newdata[i]);
			}
		})(i))
			.fail(function (xhr, statusText) {
				console.log(`xhr=${xhr}, statusText=${statusText}`);
			})
	} 
}

function handleSketchSlides(data) {
	let structure = "Dwelling";
	switch (data.TYPE) {
		case "D":
			structure = "Dwelling";
			break;
		case "O":
			structure = "Outbuilding";
			break;
		case "C":
			structure = "Commercial";
			break;
	}
	let desc = data.DESCRIB === null ? "" : data.DESCRIB;
	if (desc && desc.length > 0) {
		let temp = "".concat('/ Area: ', data.AREA);
		desc = temp.concat(' / Name: ', desc);
	}

	let thumb = "<img class=\"sp-thumbnail\" src=\"data:image/png;base64," + data.RESPONSE + "\" />";
	$("#buildingSketchViewer .sp-thumbnails").append($(thumb));

	let p2 = "<p class=\"sp-layer sp-black sp-padding\" data-position=\"bottomLeft\" data-vertical=\"0\" data-width=\"100%\" data-show-transition=\"up\"><i class=\"fas fa-drafting-compass\" aria-hidden=\"true\"></i>" +
		"<span style=\"margin-left:4px;\">Type: " + structure + "</span><span style=\"margin-left:8px;\">" + desc + "</span></p>";

	let slide = "<div class=\"sp-slide\"><img class=\"sp-image\" src=\"data:image/png;base64," + data.RESPONSE + "\"  />" + p2 + "</div>";
	$("#buildingSketchViewer .sp-slides").append($(slide))
	loadSketchSlider();
}

function loadSketches(url) {
	return new Promise((resolve) => {
		sketch_url = url;
		let sk = document.getElementById('buildingSketch');
		if (sk) {

			$("#buildingSketch .sp-no-sketch").remove();
			$("#buildingSketchViewer").remove();


			getSketchData(url)
				.then(function (result) {
					let sketch_count = 0;
					let obj = JSON.parse(result);
					if (obj.rows.length > 0) {
						sketch_count = obj.rows.length;
						let parent = document.createElement('div');
						parent.setAttribute("id", "buildingSketchViewer");
						parent.setAttribute("class", "pao-sketch slider-pro d-none");

						let slides = document.createElement('div');
						slides.setAttribute("class", "sp-slides");
						parent.appendChild(slides);

						let thumbs = document.createElement('div');
						thumbs.setAttribute("class", "sp-thumbnails");
						parent.appendChild(thumbs);
						sk.appendChild(parent);

						$.each(obj, function (idx, data) {
							if (idx === 'rows') {
								if (data.length > 0) {
									getSketchGeometry(data);
								}
							}
						});
					}
					paoDetails.modules.sketches.loaded = true;
					return sketch_count;
				})
				.then((result) => {
					resolve(result);
				});
		}
	}).catch((err) => console.error(err));
}

function addSketchWidget() {

	let widgets = document.getElementById('sketchUseColorButton');
	if (widgets) {

		let colorMode = (paoDetails.modules.sketches.sketchesUseColor === true ? "mode-bw" : "mode-color");
		let showtext = (paoDetails.modules.sketches.sketchesUseColor === true ? "Show sketches in black & white" : "Show sketches in color");

		let btn = document.getElementById('sketchUseColorButton');

		btn.setAttribute("title", showtext);
		btn.setAttribute("aria-label", showtext);

		let anchor = document.getElementById('sketchUseColor');
		anchor.className = "nav-link pao-nav pao-nav-sketch-usecolor sketch-use-color active " + colorMode;

		let parent = document.getElementById('buildingSketchViewer');

		for (let i = 0; i < parent.childNodes.length; i++) {
			if (parent.childNodes[i].className == "sp-full-screen-button sp-fade-full-screen") {
				parent.insertBefore(widgets, parent.childNodes[i]);
				break;
			}
		}
	} else {
		createSketchWidget();
	}

}

function createSketchWidget() {

	let colorMode = (paoDetails.modules.sketches.sketchesUseColor === true ? "mode-bw" : "mode-color");
	let showtext = (paoDetails.modules.sketches.sketchesUseColor === true ? "Show sketches in black & white" : "Show sketches in color");

	let fragment = document.createDocumentFragment();

	let nav = document.createElement('nav');
	nav.setAttribute("id", "sketchWidgets");
	nav.className = "nav nav-pills nav-sketch";

	let anchor = document.createElement('a');
	anchor.setAttribute("id", "sketchUseColor");
	anchor.className = "nav-link pao-nav pao-nav-sketch-usecolor sketch-use-color active " + colorMode;
	anchor.setAttribute("data-toggle", "tab");
	anchor.setAttribute("href", "#");
	anchor.setAttribute("role", "nav");
	anchor.setAttribute("aria-controls", "sketch-color");
	anchor.setAttribute("aria-selected", "false");
	nav.appendChild(anchor);

	fragment.appendChild(nav);

	let toggleColorMode = document.createElement('div');
	toggleColorMode.setAttribute("id", "sketchUseColorButton");
	toggleColorMode.setAttribute("title", showtext);
	toggleColorMode.setAttribute("aria-label", showtext);

	toggleColorMode.className = "m-0 p-0";
	toggleColorMode.appendChild(fragment);

	let parent = document.getElementById('buildingSketchViewer');
	parent.appendChild(toggleColorMode);

	toggleColorMode.addEventListener("click", async () => {
		paoDetails.modules.sketches.sketchesUseColor = !paoDetails.modules.sketches.sketchesUseColor;
		let result = await loadSketches(sketch_url);
		removeBusy('buildingSketch');
		handleSketchPostResult(result);
	});
}

function loadSketchSlider() {

	$('#buildingSketchViewer').sliderPro({
		width: 551,
		height: 416,
		responsive: true,					
		imageScaleMode: 'contain',	
		autoScaleLayers: true, 	
		autoplay: false,					
		arrows: true,							
		fadeArrows: true,					
		buttons: false,						
		fullScreen: true,					
		shuffle: false, 					
		waitForLayers: false,
		centerImage: true,
		thumbnailArrows: true,		
		thumbnailHeight: 85,
		thumbnailsPosition: 'bottom',
		breakpoints: {
			1200: {
				width: 460,
				height: 370
			},
			992: {
				width: 370,
				height: 350
			},
			768: {
				width: 280,
				height: 310,
				thumbnailWidth: 85,
				thumbnailHeight: 65
			},
			576: {
				width: 200,
				height: 270,
				thumbnailWidth: 75,
				thumbnailHeight: 70
			},
			570: {
				width: 500,
				height: 400
			}
		}
	});

	if (paoDetails.support.fullscreenApi !== "IE") {
		$('#buildingSketchViewer').each(function () {
			let slider = $(this).data('sliderPro');
			let n = parseInt(slider.getTotalSlides());
			if (_total_slides === n) {
				addSketchWidget();
				$('#buildingSketchViewer').sliderPro('gotoSlide', n - 1);
			}
		});
	} else {
		if (_total_slides >= 0) {
			addSketchWidget();
			$('#buildingSketchViewer').sliderPro('gotoSlide', _total_slides);
		}
	}
}